/* tslint:disable */
/* eslint-disable */
/**
 * CMS Content Model
 * This OpenAPI specification describes the content model of the CMS. This specification does not describe a micro service, as can be imagined due to the fact that the are no operations defined. Instead, this specification defines schemas, that may be used   * to be referenced in service   * to validate content objects against schemas   * to generate forms   * many more... Each schema is specified within it\'s own file. This approach has been chosen to facilitate reuse and lucidity. This all-in-one specification is provided for convenience.
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enumeration listing all tags referenceable by name.
 * @export
 * @enum {string}
 */
export const CmsMenuTags = {
  Expandable: "expandable",
  Highlighted: "highlighted"
};
